import { AlertColor, AlertPropsColorOverrides } from "@mui/material";
import { create } from "zustand";
import { OverridableStringUnion } from "@mui/types";

type Props = {
  open: boolean;
  severity?: OverridableStringUnion<AlertColor, AlertPropsColorOverrides>;
  message: string;
  handleClose: () => void;
  toast: (props: { message: string; error: boolean }) => void;
};

const useToast = create<Props>((set) => ({
  open: false,
  severity: undefined,
  message: "",
  handleClose: () => set(() => ({ open: false })),
  toast: ({ message, error }) =>
    set(() => ({ open: true, message, severity: error ? "error" : "success" })),
}));

export default useToast;
